module.exports = __webpack_public_path__ + "static/img/jc_zt_sec3_img5.95475ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceThree/jc_zt_sec3_img5.jpg
// module id = B+M8
// module chunks = 171